/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomended2Inputs */

const en_liveroomended2 = /** @type {(inputs: Liveroomended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room ended`)
};

const de_liveroomended2 = /** @type {(inputs: Liveroomended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room beendet`)
};

/**
* | output |
* | --- |
* | "Live Room ended" |
*
* @param {Liveroomended2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomended2 = /** @type {((inputs?: Liveroomended2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomended2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomended2(inputs)
	return de_liveroomended2(inputs)
});
export { liveroomended2 as "liveRoomEnded" }